export const fetchData = async (searchQuery) => {
    const url = `https://apiportalmanager.mayaland.store/list/json?search=${searchQuery}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        return await response.json();
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
};

export async function sendOrderData(orderData) {
    const url = 'https://apiportalmanager.mayaland.store/Test/EnvioOrden';

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(orderData),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        return await response.json();
    } catch (error) {
        throw new Error(`There was a problem with the fetch operation: ${error.message}`);
    }
}